<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div data-name="er-container" class="d-flex flex-column justify-content-center align-items-center">
                    <div style="height: 120px">
                        <p data-name="not-found">404</p>
                    </div>
                    <div>
                        <p data-name="not-found-desc">
                            We Couldn't Find This Page
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style lang="scss" scoped>
div[data-name="er-container"] {
    width: 760px;
    margin: 0 auto;
    min-height: calc(100vh - 135px);
    p {
        margin: 0;
        line-height: 21px;
    }
    p[data-name="not-found"] {
        color: #727CF5;
        font-size: 140px;
        font-weight: 900;
    }
    p[data-name="not-found-desc"] {
        color: #727CF5;
        font-size: 30px;
        font-weight: bold;
    }
}
</style>